import { render, staticRenderFns } from "./AnswerItem.vue?vue&type=template&id=6c7f9942&scoped=true&"
import script from "./AnswerItem.vue?vue&type=script&lang=js&"
export * from "./AnswerItem.vue?vue&type=script&lang=js&"
import style0 from "./AnswerItem.vue?vue&type=style&index=0&id=6c7f9942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7f9942",
  null
  
)

export default component.exports